import React from 'react';
import cn from 'classnames';
import DeleteAttachBtn from '../DeleteAttachBtn/DeleteAttachBtn';
import styles from './SelectedImg.module.scss';

const SelectedImage = ({
  photo,
  margin,
  direction,
  top,
  left,
  onClick,
  onDelete,
}) => {
  return (
    <div
      style={{
        margin,
        height: photo.height,
        width: photo.width,
        ...(direction === 'column' ? { position: 'absolute', left, top } : {}),
      }}
      className={cn('block-with-delete-button', styles.root)}
    >
      <DeleteAttachBtn
        onClick={() => onDelete(photo)}
        className={styles.deleteBtn}
      />
      <img
        alt={photo.name}
        className={styles.img}
        {...photo}
        onClick={() => onClick(photo)}
      />
      <style>{`.block-with-delete-button:hover
         .delete-button {display: unset !important;} 
         .delete-button {display: none !important;}
        `}</style>
    </div>
  );
};

export default SelectedImage;
